export default {"src":"/_next/static/media/yacht.1ecd428f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};